import { Banner, BannerMessage, ClickableBanner, LoadingScreen, TopBanner } from "component/banner";
import { Pad } from "component/basics";
import { Tag } from "component/button";
import { colorTextPrimaryOnLightColorBg } from "component/color";
import { RichText } from "component/richtext";
import { Heading } from "component/text";
import { component, DemoBox, demoFile } from "system/demo";

demoFile('component/banner', {
    designUrl: 'https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=1278-9461&t=MC9nppcf9h2iJDKP-1'
})

function TopBannerDemo() {
    return <TopBanner>
        <RichText text='🚧 **Moderation under construction:** We are still tuning auto-moderator triggering' color={colorTextPrimaryOnLightColorBg}/>
    </TopBanner>;
}
component('TopBanner', TopBannerDemo);

function BannerDemo() {
    return <DemoBox>
        <Banner>
            <Heading text='This is a warning' />
            <Pad size={16} />
            <RichText text='This is a **very** important problem'/>
        </Banner>
        <Banner>
            <Tag type='subtle' text='Recommendation' />
            <Pad size={16} />
            <Heading text='This is a recommendation' />
            <Pad size={16} />
            <RichText text='This is a **very** important problem'/>
        </Banner>
    </DemoBox>;
}
component('Banner', BannerDemo);

function ClickableBannerDemo() {
    return <DemoBox>
        <ClickableBanner onPress={() => {}}>
            <RichText text='This is a **very** important problem. You need to make sure you address it or terrible things will happen. Click the info box to learn more.'/>
        </ClickableBanner>
        <Pad/>
        <ClickableBanner onPress={() => {}}>
            <RichText text='This is a **minor** problem. Click to close'/>
        </ClickableBanner>
    </DemoBox>;
}
component('ClickableBanner', ClickableBannerDemo);

component('BannerMessage', BannerMessage, {args: {text: 'Banner Message'}})

const LoadingScreenDemo = () => <LoadingScreen />;
component('LoadingScreen', LoadingScreenDemo);

